import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  toggleVisibility({detail: { direction}}) {
    this.element.hidden = direction !== "INBOUND";
  }
}
